import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
	path: '/',
	name: 'Home',
	component: () => import('../views/Home.vue'),
	meta: {
		title: ''
	}
}, {
	path: '/project/:projectId',
	name: 'tempIndex',
	component: () => import('../views/tempIndex/tempIndex.vue'),
	props: true // 启用 props 接收参数
}, {
	path: '/Intr',
	name: 'Intr',
	component: () => import('../views/Introduction/Introduction'),
	children: [{
		path: '',
		name: 'introduce',
		component: () => import('../views/Introduction/introduce'),
		meta: {
			title: '项目介绍'
		}
	}, {
		path: 'flowPath',
		name: 'flowPath',
		component: () => import('../views/Introduction/flowPath'),
		meta: {
			title: '参与流程'
		}
	}, {
		path: 'condition',
		name: 'condition',
		component: () => import('../views/Introduction/condition'),
		meta: {
			title: '投稿要求'
		}
	}, {
		path: 'statement',
		name: 'statement',
		component: () => import('../views/Introduction/statement'),
		meta: {
			title: '作品原创及授权声明'
		}
	}]
}, {
	path: '/contribute',
	name: 'contribute',
	component: () => import('../views/contribute/contribute'),
	meta: {
		title: '作品专区'
	}
}, {
	path: '/ContentDetails',
	name: 'ContentDetails',
	component: () => import('../views/ContentDetails/ContentDetails'),
	meta: {
		title: '新闻中心'
	}
}, {
	path: '/newsCenter',
	name: 'newsCenter',
	component: () => import('../views/newsCenter/newsCenter'),
	meta: {
		title: '新闻中心'
	}
}, {
	path: '/ContactUs',
	name: 'ContactUs',
	component: () => import('../views/ContactUs/ContactUs'),
	meta: {
		title: '联系我们'
	}
}, {
	path: '/UserCenter',
	name: 'UserCenter',
	component: () => import('../views/UserCenter/UserCenter'),
	meta: {
		title: '参与投稿'
	}
}, {
	path: '/Welcome',
	name: 'Welcome',
	component: () => import('../views/Welcome/Welcome'),
	meta: {
		title: '欢迎辞'
	}
}, {
	path: '/Judges',
	name: 'Judges',
	component: () => import('../views/Judges/Judges'),
	meta: {
		title: '专家评委会'
	}
}, {
	path: '/workdetail',
	name: 'workdetail',
	component: () => import('../views/workdetail/workdetail'),
	meta: {
		title: '作品详情'
	}
}, {
	path: '/switchItems',
	name: 'switchItems',
	component: () => import('../views/switchItems/switchItems'),
	meta: {
		title: '选择项目'
	}
}, {
	path: '/filePreview',
	name: 'filePreview',
	component: () => import('../views/filePreview/filePreview'),
	meta: {
		title: '文件预览'
	}
},




	{
	path: '/:pathMatch(.*)*',
	name: 'NotFound',
	component: () => import('../components/NotFound.vue'),
	meta: {
		title: '404'
	}
}]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
	linkActiveClass: 'active'
})

router.beforeEach((to, from, next) => {
	if (to.name == 'NotFound') {
		next()
		return;
	}
	console.log(to, from, next)

	// if (to.path !== '/switchItems' && !localStorage.getItem('projectId')) {
	// 	next('/switchItems');
	// }
	if (to.name === 'tempIndex' && !/^\d+$/.test(to.params.projectId)) {
		console.log('项目ID格式错误，跳转404');
		next({
			name: 'NotFound'
		}); // 跳转至错误页
	}
	// 不需要 projectId 的路由白名单
	const whiteList = ['tempIndex', 'filePreview']
	if (!whiteList.includes(to.name) && !(localStorage.getItem('projectId'))) {
		console.log('未携带项目ID，跳转404');
		next({
			name: 'NotFound'
		}); // 跳转至错误页
	}

	// 让页面回到顶部
	document.documentElement.scrollTop = 0
	// 调用 next()，一定要调用 next 方法，否则钩子就不会被销毁
	if (to.name != 'nopath') {
		// if (to.meta.title) {
		// 	document.title = `肺炎智识之光-${to.meta.title}`
		// } else {
		// 	document.title = `肺炎智识之光-科普征文项目`
		// }
		if (to.meta.title) {
			document.title = localStorage.getItem('projectName') + `-${to.meta.title}`
		} else {
			document.title = localStorage.getItem('projectName') + `项目`
		}
		next();
	}

})

export default router
